import type { ContactMessage } from '../../../types';
import { MessageCard } from './MessageCard';

interface MessageListProps {
  messages: ContactMessage[];
  onDelete: (id: string) => void;
}

export function MessageList({ messages, onDelete }: MessageListProps) {
  return (
    <div className="admin-messages-list">
      {messages.map((msg) => (
        <MessageCard key={msg.id} msg={msg} onDelete={onDelete} />
      ))}
    </div>
  );
}
